<div class="cr-button-wrapper" *appRequiredPerms="requiredPermissions" [ngClass]="cssClasses">
  <button
    type="button"
    class="cr-button"
    [disabled]="isDisabled || isLoading"
    [class.disabled]="isDisabled || isLoading"
    [class.loading]="isLoading"
    [routerLink]="goBack ? null : routerLink"
    [attr.aria-busy]="isLoading ? 'true' : null"
    (click)="onClick()">
    <span class="label">
      <ng-content></ng-content>
    </span>

    @if (isLoading) {
      <span class="overlay-spinner">
        <span class="spinner"></span>
      </span>
    }
  </button>
</div>
